import { formatDate } from "../../utils/FormatUtils.js";
import { Date_Long, Not_Available } from "../../utils/FormatConstants.js";
const defaultZoneName = "momentTimezone.defaultZone.name";
function getStatusMsg(analysisTask) {
  let stateInfo = analysisTask.StateInfo;
  let overall = stateInfo.OverallState;
  let subState = stateInfo.SubState ? " (" + stateInfo.SubState + ")" : "";
  return overall + subState;
}
function getTaskLinkInfo(analysisTask) {
  let scorecardLink = null;
  let etaTime = null;
  let etaMsg = null;
  let etaDetail = null;
  let notifyEnabled = false;
  let isHighlighted = false;
  if (analysisTask) {
    scorecardLink = analysisTask.XCardLink;
    if (analysisTask.EstimatedArrival) {
      etaTime = analysisTask.EstimatedArrival.EstimatedArrivalTime;
      etaMsg = analysisTask.EstimatedArrival.EstimatedArrivalDisplayMsg;
      etaDetail = analysisTask.EstimatedArrival.EstimatedArrivalDetailMsg;
    }
    notifyEnabled = analysisTask.ScorecardNotificationEnabled;
  }
  return {
    scorecardLink,
    etaTime,
    etaMsg,
    etaDetail,
    notifyEnabled,
    isHighlighted
  };
}
function getTaskStatusInfo(analysisTask) {
  let stateInfo = analysisTask.StateInfo;
  let stateMessage = stateInfo.OverallState;
  let subStateMessage = !stateInfo.SubState ? "" : stateInfo.SubState;
  let dateMessage = formatDate(stateInfo.LastUpdatedTime, Date_Long, defaultZoneName);
  return {
    stateMessage,
    subStateMessage,
    dateMessage
  };
}
function getVC(analysisTask) {
  if (typeof analysisTask.ExecutionConfigurationOverrides === "undefined") {
    return null;
  }
  var vc = analysisTask.ExecutionConfigurationOverrides.VC;
  if (vc) {
    return vc;
  }
  return null;
}
function getTaskPriority(analysisTask) {
  if (typeof analysisTask.ExecutionConfigurationOverrides === "undefined") {
    return Not_Available;
  }
  var adjustedPriority = analysisTask.ExecutionConfigurationOverrides.AdjustedCosmosPriority;
  if (adjustedPriority) {
    return adjustedPriority;
  }
  var cosmosPriority = analysisTask.ExecutionConfigurationOverrides.CosmosPriority;
  if (cosmosPriority) {
    return cosmosPriority;
  }
  return Not_Available;
}
function isOneOffTask(analysisTask) {
  return analysisTask.DateRange.Start === null && analysisTask.DateRange.End === null;
}
const convertScorecardRequestToTaskOverview = (scorecardRequest) => {
  var _a, _b, _c;
  if (scorecardRequest == null ? void 0 : scorecardRequest.value) {
    return {
      TaskId: +scorecardRequest.value.taskId,
      StudyId: +scorecardRequest.value.analysisId,
      ExperimentStepId: (_a = scorecardRequest.value.experimentMetadata) == null ? void 0 : _a.experimentStepId,
      ExperimentPlanId: ((_b = scorecardRequest.value.experimentMetadata) == null ? void 0 : _b.experimentId) || "",
      AnalysisItemId: scorecardRequest.value.analysisRequestId || "",
      AnalysisTemplateName: "",
      ScorecardId: +scorecardRequest.value.id,
      WorkspaceId: ((_c = scorecardRequest.value.experimentMetadata) == null ? void 0 : _c.workspaceId) || ""
    };
  }
  return void 0;
};
export {
  convertScorecardRequestToTaskOverview,
  getStatusMsg,
  getTaskLinkInfo,
  getTaskPriority,
  getTaskStatusInfo,
  getVC,
  isOneOffTask
};
//# sourceMappingURL=AnalysisTaskUtils.js.map
